var React = require('react');
var ReactNative = require('react-native');
var NativeAppEventEmitter = require('./wrappers/NativeAppEventEmitter-wrapper');

var Animated = require('./wrappers/Animated')

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  DeviceEventEmitter,
  Platform,
  StyleSheet,
} = ReactNative;


var MKSegmentControl = require('./MKSegmentControl.js');
var ReUpButton = require('./ReUpButton.js');
var PRICE_BUTTON_WIDTH = 120;

var PriceChooserView = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      initialAmount : null,
      initialLayout : {},
      initialIndex : 4,
      choiceValue: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200],
      didChangeValueAndText : function(value, text){},
    }
  },

  getInitialState : function()
  {
    var appManager = this.props.appManager;
    var choiceValue = this.props.choiceValue;
    var locMan = appManager.getLocalizationManager();
    var choiceText = [];
    for( var i = 0; i < choiceValue.length; i++ )
    {
      choiceText.push(locMan.localizedDollars(choiceValue[i]));
    }

    var initialIndex = this.props.initialIndex;
    if( this.props.initialAmount != null )
    {
      for( var i = 0; i < choiceValue.length; i++ )
      {
        if( this.props.initialAmount == choiceValue[i] )
        {
          initialIndex = i;
          break;
        }
      }
    }
    return {
      layout : this.props.initialLayout,
      choiceIndex : initialIndex,
      isEditingAmount:false,
      chooserOpacity:new Animated.Value(0),
      buttonOpacity:new Animated.Value(1),
      choiceText : choiceText,
      choiceValue : choiceValue,
    }
  },

  componentDidMount : function()
  {
    this._ref_choicesScrollView.scrollTo({x: -this.state.layout.width/2 + PRICE_BUTTON_WIDTH/2 + PRICE_BUTTON_WIDTH*this.state.choiceIndex, y: 0, animated: true});
    var index = this.state.choiceIndex;

    this.props.didChangeValueAndText(this.state.choiceValue[index],this.state.choiceText[index]);
  },

  getAmount : function()
  {
    return this.state.choiceValue[this.state.choiceIndex];
  },

  setAmount : function(amount)
  {
    for( var i = 0; i < this.state.choiceValue.length; i++ )
    {
      if( this.state.choiceValue[i] == amount )
      {
        this.props.didChangeValueAndText(this.state.choiceValue[i], this.state.choiceText[i])
        this._ref_choicesScrollView.scrollTo({x: -this.state.layout.width/2 + PRICE_BUTTON_WIDTH/2 + PRICE_BUTTON_WIDTH*i, y: 0, animated: true});
        this._ref_choices.setSelectedIndex(i);
        this.setState({choiceIndex : i, isEditingAmount:false });
        break;
      }
    }
  },

  getAmountText : function()
  {
    return this.state.choiceText[this.state.choiceIndex];
  },

  focus : function()
  {
    var thisThing = this;
    Animated.timing(
     thisThing.state.chooserOpacity,
     {toValue: 1,
     duration:150},
    ).start(function()
    {
      thisThing.setState({isEditingAmount:true})
    });
    Animated.timing(
     thisThing.state.buttonOpacity,
     {toValue: 0,
     duration:150},
    ).start(function()
    {
    });
    if( typeof this.props.didStartChoosingPrice !== 'undefined' ) this.props.didStartChoosingPrice();
  },

  choiceSelected : function(index)
  {
    this.props.didChangeValueAndText(this.state.choiceValue[index],this.state.choiceText[index]);
    this._ref_choicesScrollView.scrollTo({x: -this.state.layout.width/2 + PRICE_BUTTON_WIDTH/2 + PRICE_BUTTON_WIDTH*index, y: 0, animated: true});
    var thisThing = this;
    this.setState({choiceIndex : index, isEditingAmount:false });
    setTimeout(function()
    {
      Animated.timing(
       thisThing.state.chooserOpacity,
       {toValue: 0,
       duration:150},
      ).start(function()
      {

      });
      Animated.timing(
       thisThing.state.buttonOpacity,
       {toValue: 1,
       duration:150},
      ).start(function()
      {
      });
    },250)
    if( typeof this.props.didEndChoosingPrice !== 'undefined' ) this.props.didEndChoosingPrice();
  },

  render : function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");

    return (
      <View style={this.props.style}>
        <Animated.View style={{flex:1, position:'absolute',top:0,left:0,right:0, height:50, flexDirection:'column',alignItems:'center', justifyContent:'center', padding:8, opacity:this.state.buttonOpacity}} pointerEvents={!this.state.isEditingAmount ? 'auto' : 'none'}>
          <ReUpButton isSecondary={true}  style={{width:PRICE_BUTTON_WIDTH,flex:1}} appManager={appManager}
           text={this.state.choiceText[this.state.choiceIndex]}
           icon={"angle-left"}
           rightIcon={"angle-right"}
           iconSize={20}
            onPress={() => {
              Animated.timing(
               thisThing.state.chooserOpacity,
               {toValue: 1,
               duration:150},
              ).start(function()
              {
                thisThing.setState({isEditingAmount:true})
              });
              Animated.timing(
               thisThing.state.buttonOpacity,
               {toValue: 0,
               duration:150},
              ).start(function()
              {
                thisThing.setState({isEditingAmount:true})
              });
              if( typeof thisThing.props.didStartChoosingPrice !== 'undefined' ) thisThing.props.didStartChoosingPrice();
            }}
            />
        </Animated.View>
        <Animated.View style={{flex:1, position:'absolute',top:0,left:0,right:0, height:50, opacity:this.state.chooserOpacity}} pointerEvents={this.state.isEditingAmount ? 'auto' : 'none'}>
          <ScrollView ref={(c) => { this._ref_choicesScrollView = c; }}
            bounces={true}
            keyboardShouldPersistTaps={true}
            keyboardDismissMode={"interactive"}
            horizontal={true}
            scrollEnabled={this.state.isEditingAmount}
            snapToInterval={PRICE_BUTTON_WIDTH}
            snapToAlignment={'center'}
            style={{backgroundColor:primaryButtonBorderColor, height:50}}>
            <MKSegmentControl
              ref={(c) => { this._ref_choices = c; }}
              style={[{height:50, flex:1, alignSelf:'center'},{width:this.state.choiceText.length*PRICE_BUTTON_WIDTH, marginTop:10}]}
              selectedIndex={this.state.choiceIndex}
              choiceTitles={this.state.choiceText}
              didSelectIndex={thisThing.choiceSelected}
              activeBackgroundColor={primaryButtonColor}
              activeShadowColor={primaryButtonBorderColor}
              activeTextColor={primaryButtonTitleColor}
              inactiveBackgroundColor={secondaryButtonColor}
              inactiveTextColor={secondaryButtonTitleColor}/>
          </ScrollView>
        </Animated.View>
      </View>
    )
  }
})

module.exports = PriceChooserView;
